/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable indent */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Checkbox,
  Grid,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Input as InputIcon } from '@material-ui/icons';
import TableItems, {
  StatusIcon,
  TableCell,
  TableRow,
} from 'components/TableItems';
import { TableCellHeaderProps } from 'components/TableItems/interfaces';
import { useTableFilters } from 'hooks/useTableFilters';
import i18n from 'i18n';
import { modalClose } from 'modules/modal/actions';
import {
  getOperatorRolesRequest,
  setPendingPermissionsRequest,
} from 'modules/operators/actions';
import {
  OperatorPermissionRoles,
  OperatorRolesResponse,
  OperatorRolesResults,
} from 'modules/operators/interfaces';
import { GetOperatorRolesRequest } from 'modules/operators/requestInterfaces';
import { getAllRolesRequest } from 'modules/permission/actions';
import { mapPermissionName } from 'modules/permission/helpers';
import { ListRoleDataProps } from 'modules/permission/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import Button from 'components/Button';
import { SearchBar } from 'components/SearchBar';
import clsx from 'clsx';
import styles from './styles';

const useStyles = makeStyles(styles);

interface OperatorRolesAvailableProps {
  isEdit?: boolean;
  isLoading: boolean;
  isLoadingOperatorRoles: boolean;
  operatorRoles: OperatorRolesResponse;
  operatorRoleTemplate: string;
  operatorRolesUuid: OperatorPermissionRoles[];
  roleList: ListRoleDataProps;
  getAllRolesRequest: ({ query, operator_role }) => void;
  getOperatorRolesRequest: (props: GetOperatorRolesRequest) => void;
  modalClose: () => void;
  setPendingPermissionsRequest: (props: OperatorPermissionRoles[]) => void;
}

const OperatorRolesAvailable = ({
  isEdit,
  isLoading,
  isLoadingOperatorRoles,
  operatorRoles,
  operatorRoleTemplate,
  operatorRolesUuid,
  roleList,
  getAllRolesRequest,
  getOperatorRolesRequest,
  modalClose,
  setPendingPermissionsRequest,
}: OperatorRolesAvailableProps) => {
  const { id } = useParams<{ id?: string }>();
  const classes = useStyles();
  const history = useHistory();
  const {
    query,
    handleLimitChange,
    handleOrder,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters();

  const [refresh, setRefresh] = React.useState(false);
  const [checks, setChecks] = React.useState<OperatorPermissionRoles[]>(
    operatorRolesUuid
  );
  const [selectedAll, setSelectedAll] = React.useState(false);

  const headers: Array<TableCellHeaderProps> = [
    {
      key: 'name',
      i18n: i18n.t('GROUP_KEY'),
      order: true,
    },
    {
      key: 'from_template',
      i18n: i18n.t('Template'),
      centerTitle: true,
      order: true,
    },
    {
      key: 'is_associated',
      i18n: i18n.t('STATUS_KEY'),
      order: true,
    },
  ];

  const getOperatorRoles = (refresh = false) => {
    if (isEdit) {
      getOperatorRolesRequest({
        showAllRoles: true,
        operatorUuid: id!,
        query: {
          ordering: '-is_associated',
          ...query,
          operator_role: operatorRoleTemplate,
        },
      });
    } else {
      getAllRolesRequest({
        operator_role: operatorRoleTemplate,
        query,
      });
    }
    setRefresh(refresh);
  };

  React.useEffect(() => {
    getOperatorRoles();
  }, [id, query]);

  const handleCheck = (role_uuid: string) => {
    const isAlreadyChecked = checks.find(role => role.role_uuid === role_uuid);
    const checksUpdated = isAlreadyChecked
      ? checks.filter(role => role.role_uuid !== role_uuid)
      : [...checks, { role_uuid }];

    setChecks(checksUpdated);
    setPendingPermissionsRequest(checksUpdated);
  };

  const handleAllCheck = () => {
    let checksUpdated: OperatorPermissionRoles[] = [];
    if (!selectedAll) {
      checksUpdated = isEdit
        ? operatorRoles.results.map(role => ({
            role_uuid: role?.role_uuid,
          }))
        : roleList.results.map(role => ({
            role_uuid: role?.role_uuid,
          }));
    }
    setChecks(checksUpdated);
    setPendingPermissionsRequest(checksUpdated);
    setSelectedAll(!selectedAll);
  };

  return (
    <>
      <Grid container alignItems="center" justify="space-between">
        <Grid item xs={10}>
          <SearchBar
            id="search-groups"
            isLoading={isEdit ? isLoadingOperatorRoles : isLoading}
            handleSearch={handleSearch}
            setSearchValue={setSearchValue}
          />
        </Grid>
        <Grid item className={classes.searchButton}>
          <Button
            onClick={() => handleSearch()}
            id="search-all-groups"
            variant="outlined"
            disabled={isEdit ? isLoadingOperatorRoles : isLoading}
            className={clsx(classes.searchButtonSize, {
              [classes.buttonIsLoading]: isEdit
                ? isLoadingOperatorRoles
                : isLoading,
            })}
          >
            <Typography>{i18n.t('SEARCH_ALL_KEY')}</Typography>
          </Button>
        </Grid>
      </Grid>
      <TableItems
        header={
          <>
            <TableCell style={{ width: 40 }} className={classes.checkboxCell}>
              <Checkbox id="select-all-groups" onClick={handleAllCheck} />
            </TableCell>
            <TableCell className={classes.accessButtonHeader} centerTitle>
              {i18n.t('ACCESS_KEY')}
            </TableCell>
            {headers.map(item => (
              <TableCell
                centerTitle={item?.centerTitle}
                key={item?.key}
                order={item?.order}
                handleOrder={() =>
                  item?.order ? handleOrder(item?.key) : null
                }
              >
                {item?.i18n}
              </TableCell>
            ))}
          </>
        }
        renderItems={(item: OperatorRolesResults) => (
          <TableRow key={item?.role_uuid}>
            <TableCell className={classes.checkboxCell}>
              <Checkbox
                id="select-groups"
                onClick={() => handleCheck(item?.role_uuid)}
                checked={
                  !!checks.find(role => role?.role_uuid === item?.role_uuid)
                }
              />
            </TableCell>
            <TableCell ellipsis centerTitle className={classes.centerFields}>
              <InputIcon
                onClick={() => {
                  history.push(`/groups/${item?.role_uuid}`);
                  modalClose();
                }}
                className={classes.accessButton}
              />
            </TableCell>
            <TableCell className={classes.text}>
              <Tooltip title={item?.name}>
                <Typography>{item?.name}</Typography>
              </Tooltip>
            </TableCell>
            <TableCell centerTitle>
              {mapPermissionName(item?.from_template)}
            </TableCell>
            <TableCell
              tooltip={i18n.t(
                item?.is_associated
                  ? 'GROUPS_PAGE.ASSOCIATE_KEY'
                  : 'GROUPS_PAGE.NOT_ASSOCIATE_KEY'
              )}
            >
              <Grid container alignItems="center" className={classes.status}>
                <StatusIcon
                  status={item?.is_associated ? 'success' : 'blocked'}
                />
                <Typography>
                  {i18n.t(
                    item?.is_associated
                      ? 'GROUPS_PAGE.ASSOCIATE_KEY'
                      : 'GROUPS_PAGE.NOT_ASSOCIATE_KEY'
                  )}
                </Typography>
              </Grid>
            </TableCell>
          </TableRow>
        )}
        data={isEdit ? operatorRoles : roleList}
        isLoading={!refresh && (isEdit ? isLoadingOperatorRoles : isLoading)}
        onChangePage={handlePageChange}
        onChangeLimit={handleLimitChange}
        notFoundText={i18n.t('GROUPS_PAGE.NO_GROUPS_KEY')}
      />
    </>
  );
};

const mapStateToProps = ({
  operators: { checks, isLoadingOperatorRoles, operatorRoles },
  permission: { isLoading, roleList },
}: ApplicationState) => ({
  operatorRolesUuid: checks,
  isLoading,
  isLoadingOperatorRoles,
  operatorRoles,
  roleList,
});

export default connect(mapStateToProps, {
  getAllRolesRequest,
  getOperatorRolesRequest,
  modalClose,
  setPendingPermissionsRequest,
})(OperatorRolesAvailable);
